/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {defineStore} from 'pinia';
import {backend} from '@/api/backend';
// @ts-expect-error
import {ProductView} from '@proto/teamdev/licensing/q/product/product_view_pb';

interface ProductsState {
  values: ProductView[],
  initialized: boolean,
}

function initialState(): ProductsState {
  return {
    values: [],
    initialized: false,
  };
}

/**
 * The store with the list of products.
 */
const useProductsStore = defineStore('products', {
  state: (): ProductsState => initialState(),
  actions: {
    async init(): Promise<void> {
      if (this.initialized) {
        return;
      }
      this.values = [];
      this.values = await backend().select(ProductView)
                                   .run();
      this.initialized = true;
    },
    reset() {
      this.$patch(initialState());
    }
  },
});

export default useProductsStore;
